import {Component, OnInit} from '@angular/core';
import {ScheduleService, setOfMonthSettings, setOfPeriods} from '../../services/ScheduleService';
import {FormsModule} from '@angular/forms';
import {DatePicker} from 'primeng/datepicker';
import {Select} from 'primeng/select';
import {RadioButton} from 'primeng/radiobutton';
import {InputNumber} from 'primeng/inputnumber';
import {Checkbox} from 'primeng/checkbox';
import dayjs from 'dayjs';

declare var Yii: any;

@Component({
  selector: 'ng-schedule-main-settings',
  templateUrl: './main-settings.html',
  imports: [
    FormsModule,
    DatePicker,
    Select,
    RadioButton,
    InputNumber,
    Checkbox
  ]
})
export class AssignmentsScheduleMainSettingsComponent implements OnInit {
  public Yii = Yii;
  public setOfPeriods = setOfPeriods;
  public setOfMonthSettings = setOfMonthSettings;

  public weekly_repeat_settings: any[] = []
  public start_day: Date = new Date()
  public end_day: Date|null = null

  constructor(public ssvc: ScheduleService) {}

  ngOnInit(): void {
    this.weekly_repeat_settings = JSON.parse(this.ssvc.settings.schedule.weekly_repeat_settings)
    this.start_day = new Date(this.ssvc.settings.schedule.start_day)
    if(this.ssvc.settings.schedule.end_condition_param_on_date !== null) {
      this.end_day = new Date(this.ssvc.settings.schedule.end_condition_param_on_date)
    } else {
      this.end_day = null
    }
  }

  changeStartDay(date: Date) {
    this.start_day = date
    this.ssvc.settings.schedule.start_day = dayjs(date).format('YYYY-MM-DD')
  }

  changeEndDay(date: Date) {
    this.end_day = date
    this.ssvc.settings.schedule.end_condition_param_on_date = dayjs(date).format('YYYY-MM-DD')
  }
}
